"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetFullContextQuerySchema = exports.GetFullContextResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
/**
 * Responses
 */
exports.GetFullContextResponseSchema = (0, core_1.StrictObject)({
    team: typebox_1.Type.Optional(ruby_1.TeamContextSchema),
    campaign: typebox_1.Type.Optional(ruby_1.CampaignContextSchema),
    user: ruby_1.UserContextSchema,
    tier: typebox_1.Type.Optional(ruby_1.TierContextSchema),
    member: typebox_1.Type.Optional(ruby_1.MemberContextSchema),
});
/**
 * Parameters
 */
exports.GetFullContextQuerySchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    subject: typebox_1.Type.Optional(ruby_1.SubjectSchema),
    userId: typebox_1.Type.Optional(core_1.IdSchema),
});
